<template>
  <div class="organizations-container full-height-loading">
    <page-header title="Organizations">
      <div slot="sub-title">
        <fa icon="building" />
        Manage and browse organizations
      </div>
    </page-header>

    <el-row :gutter="20" class="body-padding">
      <el-col :span="24" class="organizations-category-controls">
        <el-radio-group v-model="view">
          <el-radio-button label="My organizations"></el-radio-button>
          <el-radio-button label="Find organizations"></el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="24" v-loading="loading">
        <browse-organizations
          :organizations="nonMemberOrganizations"
          @requestMembershipSuccess="setOrganizationMemberState"
          v-show="isBrowsing && !loading"/>
        <user-organizations
          :organizations="memberOrganizations"
          @cancelMembershipSuccess="setOrganizationMemberState"
          @acceptMembershipSuccess="setOrganizationMemberState"
          @goBrowse="view = 'Find organizations'"
          v-show="!isBrowsing && !loading" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import UserOrganizations from './UserOrganizations'
import BrowseOrganizations from './BrowseOrganizations'
import Loader from '@/components/shared/loaders/GridLoader'

export default {
  name: 'OrganizationsContainer',
  components: { UserOrganizations, BrowseOrganizations, Loader },
  data () {
    return {
      loading: true,
      organizations: [],
      idCollection: [],
      view: 'My organizations',
      search: ''
    }
  },
  computed: {
    isBrowsing () {
      return this.view === 'Find organizations'
    },
    memberOrganizations () {
      return this.organizations.filter(item => {
        if (item.member) {
          return item
        }
      })
    },
    nonMemberOrganizations () {
      return this.organizations.filter(item => {
        if (!item.member) {
          return item
        }
      })
    }
  },
  methods: {
    setOrganizationMemberState (organization, member, pending, invite) {
      organization.member = member
      organization.pending = pending
      organization.invite = invite
    },
    createOrganizationObject (member, pending, invite, organization) {
      return { member: member, pending: pending, invite: invite, ...organization }
    },
    async getOrganizations () {
      const myOrganizationsResponse = await this.$http.get(this.$api.user(this.$auth.user.id).organizations)
      this.organizations = myOrganizationsResponse.data.map(item => {
        return this.createOrganizationObject(true, item.pending, item.invite, item.organization)
      })

      const allOrganizationsResponse = await this.$http.get(this.$api.organizations.index)
      this.organizations = [...this.organizations, ...allOrganizationsResponse.data.filter(item => {
        const isMember = this.organizations.find(org => { return org.id === item.id })
        if (isMember === undefined) {
          return this.createOrganizationObject(false, false, false, item)
        }
      })]

      this.loading = false
    }
  },
  created () {
    this.getOrganizations()
  }
}
</script>

<style lang="scss" scoped>
  .organizations-category-controls {
    margin-bottom: 30px;
    @include breakpoint (xs) {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/user/Container.vue